import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/NutriScoreLabel/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	isFluid: boolean;
	maxValue: number;
	color: string;
	rank: number;
	labelTranslations: {
		[key: string]: string;
	};
};

export const defaultResponseData = (): ResponseData => {
	return {
		id: '',
		isFluid: false,
		maxValue: 0,
		color: '',
		rank: 0,
		labelTranslations: {},
	};
};
